export const cancelEvent = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
};
const isFileAccepted = (file: File, accept: string) => {
    const { name, type } = file;

    const acceptRules = accept.split(',').map((rule) => rule.trim());

    const acceptRuleValidator = (acceptRule: string) => {
        if (acceptRule.startsWith('.')) {
            return name.toLowerCase().endsWith(acceptRule.toLowerCase());
        } else if (acceptRule.endsWith('/*')) {
            return type.startsWith(acceptRule.replace('/*', ''));
        }
        return type === acceptRule;
    };

    return acceptRules.some(acceptRuleValidator);
};

export const areAllFilesAccepted = (files: FileList | File[], accept: string) =>
    Array.from(files).every((file) => isFileAccepted(file, accept));

export const formatFileSize = (sizeInBytes: number): string => {
    const units = ['bytes', 'kB', 'MB'];
    let size = sizeInBytes;
    let unitIndex = 0;

    for (unitIndex; unitIndex < units.length - 1 && size >= 1024; unitIndex++) {
        size /= 1024;
    }

    return `${size.toFixed(2)} ${units[unitIndex]}`;
};

export const createFileList = (files: File[]) => {
    const transfer = new DataTransfer();
    files.forEach((file) => transfer.items.add(file));
    return transfer.files;
};

export const filterUniqueFiles = (files: File[]): File[] => {
    const fileMap = new Map<string, File>();
    files.forEach((file) => {
        fileMap.set(file.name, file);
    });
    return Array.from(fileMap.values());
};
